export default __webpack_public_path__ + "static/media/document-bot.0843cbe0.svg";